module.exports = __webpack_public_path__ + "assets/img/people_alt.707175a5.svg";